// This file is part of Indico.
// Copyright (C) 2002 - 2019 CERN
//
// Indico is free software; you can redistribute it and/or
// modify it under the terms of the MIT License; see the
// LICENSE file for more details.

// base colors (must match entries in _palette.scss)
const Palette = {
  blue: '#5d95ea',
};

// colors for specific purposes
Palette.highlight = Palette.blue;

export default Palette;
